var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spa-soft-progressbar",
      attrs: { "data-component": "spa-soft-progressbar" },
    },
    [
      _c("div", { staticClass: "spa-soft-progressbar-wrapper" }, [
        _c(
          "div",
          {
            ref: "statusMessage",
            staticClass: "sr-only",
            attrs: { role: "status" },
          },
          [
            _vm.currentStepMessage
              ? _c("span", [_vm._v(_vm._s(_vm.currentStepMessage))])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spa-soft-progressbar-steps" },
          _vm._l(_vm.updatedStepsData, function (step) {
            return _c(
              "button",
              {
                key: step.stepName,
                ref: _vm.isActive(step.stepIntId, step.subStepIntId)
                  ? "activeStep"
                  : null,
                refInFor: true,
                staticClass: "spa-soft-progressbar-step",
                class:
                  _vm.isActive(step.stepIntId, step.subStepIntId) && "active",
                attrs: {
                  type: "button",
                  disabled: _vm.isDisabled(step.stepIntId, step.subStepIntId),
                },
                on: {
                  click: function ($event) {
                    return _vm.buttonAction(step)
                  },
                },
              },
              [
                _c("span", { staticClass: "circle" }, [
                  _vm._v(_vm._s(step.stepNumber)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.tc(step.label))),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }